(function(){
  function initPicker(picker){
    if(!picker||picker.getAttribute('data-ml-initialized')==='true')return;
    picker.setAttribute('data-ml-initialized','true');
    var section=picker.closest('.ml-product-template');
    if(!section)return;
    var variantInput=picker.querySelector('[data-ml-variant-id]');
    var variantData=picker.querySelector('[data-ml-variants]');
    var price=section.querySelector('[data-ml-product-price]');
    var addButton=section.querySelector('[data-ml-add-button]');
    var optionInputs=Array.prototype.slice.call(picker.querySelectorAll('[data-ml-option-select]'));
    optionInputs.sort(function(a,b){return parseInt(a.getAttribute('data-option-position')||'0',10)-parseInt(b.getAttribute('data-option-position')||'0',10);});
    if(!variantInput||!variantData||!optionInputs.length)return;
    var variants=[];
    try{variants=JSON.parse(variantData.textContent||'[]');}catch(error){variants=[];}
    function updateVariant(){
      var selectedValues=optionInputs.map(function(input){return input.value;});
      var variant=variants.find(function(item){
        if(!item.options||item.options.length!==selectedValues.length)return false;
        return item.options.every(function(value,index){return String(value)===String(selectedValues[index]);});
      });
      if(!variant){
        variantInput.value='';
        if(addButton){addButton.disabled=true;addButton.textContent='Unavailable';}
        return;
      }
      variantInput.value=variant.id;
      if(price&&variant.price)price.textContent=variant.price;
      if(addButton){addButton.disabled=!variant.available;addButton.textContent=variant.available?'Add to Cart':'Sold Out';}
    }
    optionInputs.forEach(function(input){if(input.tagName==='SELECT')input.addEventListener('change',updateVariant);});
    updateVariant();
  }
  function sourceHasValue(source){
    if(source.type==='file')return !!(source.files&&source.files.length);
    return String(source.value||'').trim().length>0;
  }
  function initPersonalizationForm(form){
    if(!form||form.getAttribute('data-ml-personalization-initialized')==='true')return;
    var group=form.querySelector('[data-ml-personalization-group]');
    if(!group)return;
    form.setAttribute('data-ml-personalization-initialized','true');
    var required=group.getAttribute('data-personalization-required')==='true';
    var sources=Array.prototype.slice.call(group.querySelectorAll('[data-ml-personalization-source]'));
    var error=group.querySelector('[data-ml-personalization-error]');
    function clearError(){
      if(!sources.some(sourceHasValue))return;
      sources.forEach(function(source){source.removeAttribute('aria-invalid');});
      if(error)error.hidden=true;
    }
    sources.forEach(function(source){source.addEventListener(source.type==='file'?'change':'input',clearError);});
    form.addEventListener('submit',function(event){
      if(!required||sources.some(sourceHasValue))return;
      event.preventDefault();
      sources.forEach(function(source){source.setAttribute('aria-invalid','true');});
      if(error){error.hidden=false;error.focus();}else if(sources.length){sources[0].focus();}
    });
  }
  function initCustomerSuppliedForm(form){
    if(!form||form.getAttribute('data-ml-customer-item-initialized')==='true')return;
    var characterInput=form.querySelector('[data-ml-character-input]');
    if(!characterInput)return;
    form.setAttribute('data-ml-customer-item-initialized','true');
    var counter=form.querySelector('[data-ml-character-count]');
    var textLengthSelect=form.querySelector('[data-ml-text-length-select]');
    var orderTypeSelect=form.querySelector('[data-ml-order-type-select]');
    var quantity=form.querySelector('[data-ml-customer-item-quantity]');
    function updateCharacterTier(){
      var length=String(characterInput.value||'').length;
      if(counter)counter.textContent=String(length);
      if(!textLengthSelect||length===0)return;
      var nextValue=length>35?'36–70 characters':'1–35 characters';
      if(textLengthSelect.value!==nextValue){
        textLengthSelect.value=nextValue;
        textLengthSelect.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    function updateSetupQuantity(){
      if(!quantity||!orderTypeSelect)return;
      var isNewDesign=orderTypeSelect.value.indexOf('New design')===0;
      quantity.max=isNewDesign?'1':'';
      if(isNewDesign&&parseInt(quantity.value||'1',10)>1)quantity.value='1';
    }
    characterInput.addEventListener('input',updateCharacterTier);
    if(orderTypeSelect)orderTypeSelect.addEventListener('change',updateSetupQuantity);
    if(quantity){quantity.addEventListener('input',updateSetupQuantity);quantity.addEventListener('change',updateSetupQuantity);}
    updateCharacterTier();
    updateSetupQuantity();
  }
  function init(){document.querySelectorAll('[data-ml-option-picker]').forEach(initPicker);document.querySelectorAll('.ml-product-form').forEach(function(form){initPersonalizationForm(form);initCustomerSuppliedForm(form);});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();
